import { render, staticRenderFns } from "./Fooder.vue?vue&type=template&id=8225b078&scoped=true"
import script from "./Fooder.vue?vue&type=script&lang=ts"
export * from "./Fooder.vue?vue&type=script&lang=ts"
import style0 from "./Fooder.vue?vue&type=style&index=0&id=8225b078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8225b078",
  null
  
)

export default component.exports